import React from "react";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import VSNTextField from "../../../shared/VSNTextField";
import VSNTypography from "../../../shared/VSNTypography";

const useStyles = makeStyles((theme) => ({
  information: {
    position: "relative",
    alignItems: "center",
    maxWidth: 840,
    width: "100%",
    margin: "0 auto 48px",
    padding: "0 15px",
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      justifyContent: "center",
      marginBottom: 15,
    },
    "& h4": {
      fontSize: 22,
      lineHeight: "38.21px",
      fontWeight: 600,
      color: "var(--darkGray)",
      marginBottom: "8px",
      textAlign: "center",
      [theme.breakpoints.down("lg")]: {
        textAlign: "center",
      },
      [theme.breakpoints.down("md")]: {
        lineHeight: "31px",
        marginBottom: 10,
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 18,
        padding: [[0]],
        marginBottom: 10,
      },
    },
    "& .MuiFormControl-root": {
      width: "100%",
      "& input[type=number]": {
        "-moz-appearance": "textfield",
        "&::-webkit-outer-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "&::-webkit-inner-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
      },
      "& .MuiInputBase-root": {
        "& .MuiInputBase-input": {
          border: "1px solid #EAEDF0",
          borderRadius: "4px",
          boxShadow: "0px 9px 20px 0px #968FB01A",
          "&.MuiOutlinedInput-input": {
            minHeight: "11px",
            padding: "16px 32px",
            color: "var(--gray)",
            fontSize: 18,
            lineHeight: "20.83px",
            fontWeight: 500,
          },
        },
      },
      "& fieldset": {
        borderColor: "#EAEDF0",
      },
    },
  },
}));

const NumberOrNone = ({
  question,
  onChange,
  value,
  handelNextQuestion,
  currentQuestionIndex,
  allow_resubmission,
}) => {
  const classes = useStyles();

  const handleInputChange = (e) => {
    const inputValue = e.target.value || "";
    if (/^\d+$/.test(inputValue)) {
      const numericValue = +inputValue;
      if (numericValue >= 1 && numericValue <= 50) {
        onChange({ result: inputValue }, question, !inputValue?.trim());
      }
    } else if ("none".startsWith(inputValue.toLowerCase())) {
      onChange({ result: inputValue }, question, !inputValue?.trim());
    } else if (inputValue.toLowerCase() === "none") {
      onChange({ result: inputValue }, question, !inputValue?.trim());
    }
  };

  return (
    <Box className={classes.information}>
      <VSNTypography variant="h4" component="h4">
        {`${question?.order}. ${question?.phrase}`}
      </VSNTypography>
      <VSNTextField
        variant="outlined"
        id={question.id}
        placeHolder="Enter number between 1 and 50 or “None”"
        name={question?.phrase}
        value={value?.value?.result || ""}
        onChange={handleInputChange}
        type="text"
      />
    </Box>
  );
};

export default NumberOrNone;
